<template lang="pug">
    .content(ref="container")
            ImageContainer(
                v-for="image in contents"
                :imageObject="image"
                :maxW="singleImageMaxWidth"
                :key="image.id"
            )
</template>

<script>

// import _ from 'lodash'
import ImageContainer from './Image'
import get from 'lodash.get'
import min from 'lodash.min'
import trim from 'lodash.trim'
import debounce from 'lodash.debounce'

export default {
    name: 'ImageSection',
    components: {
        ImageContainer
    },
    data() {
        return {
            maxW: undefined,
            // aspectRatio: undefined,
            // w: undefined,
            // h: undefined,
        }
    },
    props: {
        section: {
            type: Object,
            required: true,
        },
    },
    computed: {
        contents() {
            return get(this.section, 'contents')
        },
        imageCount() {
            return this.contents.length
        },
        singleImageMaxWidth() {
            if ( this.maxW < 721) return this.maxW
            return (this.maxW / this.imageCount)
        }
    },
    mounted() {
        const calculateMaxWidth = () => {
            if (this.$refs.container) {
                const style = getComputedStyle(this.$refs.container)
                this.maxW = this.$refs.container.clientWidth
                this.maxW -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight)
            }
        }

        window.addEventListener('resize', debounce(calculateMaxWidth, 100))
        calculateMaxWidth()
    }
}
</script>

<style lang="sass" scoped>

    @import "~bulma/sass/utilities/mixins"
    @import '~@/assets/sass/variables'

    .content
        display: flex
        flex-direction: row
        align-items: flex-start
        max-width: 100%
        +mobile
            flex-direction: column
            align-items: center
            justify-content: space-between

        .image
            +mobile
                height: unset!important
            figure
                display: block
                margin-bottom: 2px
                img
                    width: auto
                    height: initial
                    border-radius: 4px
                    display: inline-block
                    &[lazy=loading]
                        box-shadow: none
                    &[lazy=loaded]
                        // max-height: 500px
                        // height: initial !important
                        // width: initial !important
                        box-shadow: $box-shadow-3
            p
                margin-bottom: 0
                font-size: .8rem
            small
                font-size: .65rem
                display: block
    .container.content
        background: $skeletonColor
</style>
